import dayjs from 'dayjs';

/**
 * Sorts an array of objects based on a specified date property.
 *
 * @param array The array of objects to be sorted.
 * @param dateProperty The name of the date property to use for sorting.
 * @param order The direction of sorting: 'asc' for ascending or 'desc' for descending.
 * @returns The sorted array.
 */
export const sortArrayByDate = <
  T extends Record<K, string>,
  K extends keyof any,
>(
  array: T[],
  dateProperty: K,
  order: 'asc' | 'desc' = 'desc',
): T[] =>
  array.sort((a: T, b: T) => {
    const dateA = dayjs(a[dateProperty]);
    const dateB = dayjs(b[dateProperty]);

    if (order === 'asc') {
      return dateA.diff(dateB);
    }
    return dateB.diff(dateA);
  });
